<template>
  <div class="DetailVideoList">
    <div class="title">会议回放</div>
    <ul :class="!off ? 'off' : ''">
      <li v-for="item in videoList" :key="item.id" @click="play(item)">
        <div class="top">
          <img :src="item.image" alt="">
        </div>
        <div class="bottom">
          <span>{{item.title}}</span>
          <span>讲者：{{item.author}}</span>
        </div>
      </li>
    </ul>
    <div v-show="!off" @click="off = 1" class="btn">更多</div>
    <div v-show="off" @click="off = 0" class="btn">收起</div>
  </div>
</template>

<script>
export default {
  name: "DetailVideoList",
  props: {
    videoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      off: 0
    }
  },
  methods: {
    play(data) {
      this.$emit('change', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.DetailVideoList {
  position: relative;
  border-bottom: 1px solid #ECECEC;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  padding-bottom: 30px;
  overflow: hidden;
  .off {
    max-height: 650px;
  }
  .btn {
    background: #ECECEC;
    width: 80px;
    height: 50px;
    font-size: 22px;
    color: #00476C;
    text-align: center;
    line-height: 50px;
    position: absolute;
    right: 25px;
    bottom: 20px;
  }
  ul {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      text-align: left;
      width: 346px;
      margin-bottom: 40px;
      .bottom {
        width: 302px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 10px 0 10px;
        display: flex;
        flex-direction: column;
        span:nth-child(1) {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 28px;
          color: #333333;
        }
        span:nth-child(2) {
          font-size: 28px;
          color: #999999;
        }
      }
      .top {
        img {
          width: 346px;
          height: 194px;
          border-radius: 10px;
        }
      }
    }
  }
  .title {
    color: #00476C;
    font-size: 34px;
    font-weight: bold;
    text-align: left;
    margin-top: 40px;
    margin-bottom: 20px;
  }
}
</style>
